export default "__VITE_ASSET__C$gK_JTs__"